import { useMemo, useState } from 'react';

import { type EkycStep, useEkyc } from '../providers';
import { useNetworkListener } from '../providers/network/useNetworkListener';

import CompletedPage from './_completed';
import { OfflineFallbackModal } from './_components';
import CaptureFacePage from './_identify/face/capture/capture-face-page';
import CaptureFaceConsentPage from './_identify/face/consent';
import CaptureFaceInstructionPage from './_identify/face/instruction';
import { CaptureBackPage, CaptureFrontPage } from './_identify/id-card/captures';
import CaptureCardConsentPage from './_identify/id-card/consent';
import IDDetailsConfirmation from './_identify/id-card/details-confirmation';
import InstructionPage from './_identify/id-card/instruction';
import OnBoardingPage from './_onboarding';
import TermsAndConditionsPage from './_terms-and-conditions';

const STEP_COMPONENT_MAP = {
  onboarding: <OnBoardingPage />,
  'terms-and-conditions': <TermsAndConditionsPage />,
  'capture-card-consent': <CaptureCardConsentPage />,
  'capture-card-instruction': <InstructionPage />,
  'capture-id-card-front': <CaptureFrontPage />,
  'capture-id-card-back': <CaptureBackPage />,
  'id-card-confirmation': <IDDetailsConfirmation />,
  'capture-face-consent': <CaptureFaceConsentPage />,
  'capture-face-instruction': <CaptureFaceInstructionPage />,
  'capture-face': <CaptureFacePage />,
  completed: <CompletedPage />,
} as const satisfies Record<EkycStep, React.ReactNode>;

export default function HomePage() {
  const { step } = useEkyc();

  const [isOpen, setIsOpen] = useState(false);

  const page = useMemo(() => {
    return STEP_COMPONENT_MAP[step as keyof typeof STEP_COMPONENT_MAP] ?? null;
  }, [step]);

  useNetworkListener({
    onDisconnect: () => {
      setIsOpen(true);
    },
    onReconnect: () => {
      setIsOpen(false);
    },
  });

  return (
    <>
      <OfflineFallbackModal open={isOpen} />
      {page}
    </>
  );
}
